export var FieldInputType;
(function (FieldInputType) {
    FieldInputType["Inline"] = "inline";
    FieldInputType["Form"] = "form";
    FieldInputType["Table"] = "table";
})(FieldInputType || (FieldInputType = {}));
